import { DetailTabHeader } from 'common/components/DetailControls/DetailTabHeader';
import { MainContainerWrapper } from 'common/components/MainContainerWrapper/MainContainerWrapper';
import { MainTitle } from 'common/components/MainContainerWrapper/styles';
import { NestedTabs } from 'common/components/NestedTabs/NestedTabs';
import { FC, useEffect, useMemo } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { Constants } from 'utils/constants';
import { HaulRates } from './Tabs/HaulRates';
import { PickRates } from './Tabs/PickRates';
import { Ranges } from './Tabs/Ranges';
import { Surcharges } from './Tabs/Surcharges';
import { TransferRates } from './Tabs/TransferRates';
import { OtherRates } from './Tabs/OtherRates';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const TitleWrapper = styled(Wrapper)`
  margin-bottom: 20px;
`;

const TableWrapper = styled(Wrapper)`
  margin-top: 20px;
`;

export const RatesView: FC = () => {
  const { url } = useRouteMatch();
  const { pathname } = useLocation();
  const history = useHistory();

  useEffect(() => {
    const tabPath = pathname.substring(url.length);

    // Redirect to surcharges tab if accessing the page without a tab.
    if (tabPath === '') {
      history.replace(`${url}${Constants.routes.FSC}`);
    }
  }, [history, pathname, url]);

  const nestedTabs = useMemo(
    () => [
      {
        header: (isSelected: boolean) => (
          <DetailTabHeader isSelected={isSelected} tabName='FSC' />
        ),
        view: () => (
          <TableWrapper>
            <Surcharges />
          </TableWrapper>
        ),
        tabPath: Constants.routes.FSC,
      },
      {
        header: (isSelected: boolean) => (
          <DetailTabHeader isSelected={isSelected} tabName='Range' />
        ),
        view: () => (
          <TableWrapper>
            <Ranges />
          </TableWrapper>
        ),
        tabPath: Constants.routes.RANGE,
      },
      {
        header: (isSelected: boolean) => (
          <DetailTabHeader isSelected={isSelected} tabName='Pick' />
        ),
        view: () => (
          <TableWrapper>
            <PickRates />
          </TableWrapper>
        ),
        tabPath: Constants.routes.PICK,
      },
      {
        header: (isSelected: boolean) => (
          <DetailTabHeader isSelected={isSelected} tabName='Haul' />
        ),
        view: () => (
          <TableWrapper>
            <HaulRates />
          </TableWrapper>
        ),
        tabPath: Constants.routes.HAUL,
      },
      {
        header: (isSelected: boolean) => (
          <DetailTabHeader isSelected={isSelected} tabName='Transfer' />
        ),
        view: () => (
          <TableWrapper>
            <TransferRates />
          </TableWrapper>
        ),
        tabPath: Constants.routes.TRANSFER,
      },
      {
        header: (isSelected: boolean) => (
          <DetailTabHeader isSelected={isSelected} tabName='Other' />
        ),
        view: () => (
          <TableWrapper>
            <OtherRates />
          </TableWrapper>
        ),
        tabPath: Constants.routes.OTHER,
      },
    ],
    [],
  );

  return (
    <MainContainerWrapper maxWidth='1100px' sidePadding={false}>
      <TitleWrapper>
        <MainTitle>Rate Settings</MainTitle>
      </TitleWrapper>
      <NestedTabs tabs={nestedTabs} />
    </MainContainerWrapper>
  );
};
